export default "/static/assets/briefcase-trend.203319190e2b45342db02620ec2988df.svg";